export default "__VITE_ASSET__B$0g_4ov__"